import { useAuthFetchWithResult } from '@e3dc-react/shell/Hooks/AuthFetch'
import { UseMutationResult } from '@tanstack/react-query'
import { InstallationPowerPricePOSTDto, updatePowerSellPrices } from 'src/Libs/flow/installation/api'
import { usePortalMutation } from 'src/Libs/api'

type Variables = {
  installationId: string
  powerSellPrice: InstallationPowerPricePOSTDto
}

interface UseUpdatePowerSellPricesParams {
  onSuccess?: (vars: Variables) => void
  onError?: (vars: Variables) => void
}

type UseUpdatePowerSellPricesReturnType = (data?: UseUpdatePowerSellPricesParams) => UseMutationResult<null, unknown, Variables>

export const useUpdatePowerSellPrices: UseUpdatePowerSellPricesReturnType = ({ onSuccess, onError } = {}) => {
  const authFetch = useAuthFetchWithResult()

  return usePortalMutation({
    mutationFn: ({ installationId, powerSellPrice }: Variables) => updatePowerSellPrices(+installationId, powerSellPrice, authFetch),
    onSuccess: (_, vars) => onSuccess?.(vars),
    onError: (_, vars) => onError?.(vars),
  })
}
